import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-more-details-dialog',
  templateUrl: './more-details-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MoreDetailsDialog implements OnInit {
  moreDetails: any;

  constructor(
    private _dialogRef: MatDialogRef<MoreDetailsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.moreDetails = this.data.details;
  }

  close() {
    this._dialogRef.close('close');
  }
}
